export const NO_MARGIN_WIDTH = '0';
export const MEDIUM_MARGIN_WIDTH = '1';
export const LARGE_MARGIN_WIDTH = '1.5';
export const NAV_MARGIN_WIDTH = '2.5';

// These sizes match what's used in utils/responsive.js
export const breakpoints = {
  xs: 0,
  sm: 48.0625, // 769px - This is the start size of "desktop" layouts. It specifically excludes iPad
  md: 64, // 1024px
  lg: 80, // 1280px
  // XL is not officially supported by react-styled-flexboxgrid, but is used by our layout. Grid properties should be the same as lg
  xl: 105, // 1680px - All sizes beyond 1440px--i.e. Marissa's monitor. Layout doesn't change after this size.
};

export const FlexboxGridMobileTheme = {
  name: 'FlexboxGridMobileTheme',
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: 1,
    outerMargin: 0.5,
    mediaQuery: 'only screen',
    breakpoints,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: MEDIUM_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridDesktopSmallTheme = {
  name: 'FlexboxGridDesktopSmallTheme',
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: MEDIUM_MARGIN_WIDTH,
    outerMargin: 0,
    mediaQuery: 'only screen',
    breakpoints,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: MEDIUM_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridDesktopMediumTheme = {
  name: 'FlexboxGridDesktopMediumTheme',
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: MEDIUM_MARGIN_WIDTH,
    outerMargin: 0,
    mediaQuery: 'only screen',
    breakpoints,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: MEDIUM_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridDesktopLargeTheme = {
  name: 'FlexboxGridDesktopLargeTheme',
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: LARGE_MARGIN_WIDTH,
    outerMargin: 0,
    mediaQuery: 'only screen',
    breakpoints,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: LARGE_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridDesktopExtraLargeTheme = {
  name: 'FlexboxGridDesktopExtraLargeTheme',
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: LARGE_MARGIN_WIDTH,
    outerMargin: 0,
    mediaQuery: 'only screen',
    breakpoints,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: NO_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridWithNavTheme = {
  name: 'FlexboxGridWithNavTheme',
  flexboxgrid: {
    gutterWidth: 0,
    outerMargin: NAV_MARGIN_WIDTH,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: NO_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridTheme = {
  name: 'FlexboxGridTheme',
  flexboxgrid: {
    gutterWidth: NO_MARGIN_WIDTH,
    outerMargin: NO_MARGIN_WIDTH,
    breakpoints,
  },
  PaddedLandingPageComponent: {
    horizontalPadding: MEDIUM_MARGIN_WIDTH + 'rem',
  },
};

export const FlexboxGridFlyerTheme = {
  name: 'FlexboxGridSlatTheme',
  flexboxgrid: {
    gutterWidth: NO_MARGIN_WIDTH,
    outerMargin: NO_MARGIN_WIDTH,
    breakpoints,
  },
};

export const FlexboxGridSlatTheme = {
  name: 'FlexboxGridSlatTheme',
  flexboxgrid: {
    gutterWidth: NO_MARGIN_WIDTH,
    outerMargin: NO_MARGIN_WIDTH,
    breakpoints,
  },
};

export const FlexboxGridThemes = {
  default: FlexboxGridMobileTheme,
  FlexboxGridMobileTheme,
  FlexboxGridDesktopSmallTheme,
  FlexboxGridDesktopMediumTheme,
  FlexboxGridDesktopLargeTheme,
  FlexboxGridDesktopExtraLargeTheme,
  FlexboxGridWithNavTheme,
  FlexboxGridTheme,
  FlexboxGridFlyerTheme,
  FlexboxGridSlatTheme,
};

export default FlexboxGridThemes;
